// removed by extract-text-webpack-plugin
module.exports = {"title":"_2H3O_uOgb_hWhqCMXjtc1p","note":"_3TACVC4in61ALnOv7nJEKq","block":"_1Okz3O0cH2Iig7D_0KkXWu","questionBlock":"_1EEYDGNOxEai00R5xyBIBl","question":"_6OJ0IRQsxg5Uh8hNeqqhc","table":"_2hFI0C8GXpy9ge-gvO6wpw","radio":"_3y5mjz4h8hQpAjRDFj0By-","button":"QdxCna1UM5WZVPfB2j013"};


//////////////////
// WEBPACK FOOTER
// ./src/css/screens/home.css
// module id = 78
// module chunks = 0